export const LOAD_CASE_LIST = 'case/LOAD_CASE_LIST';
export const LOAD_CASE_LIST_SUCCESS = 'case/LOAD_CASE_LIST_SUCCESS';
export const LOAD_CASE_LIST_ERROR = 'case/LOAD_CASE_LIST_ERROR';
